import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { class: "gfu-editor-attachment__name" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Download icon is a CSS ::before so it shows in both the editor and the exported <a> (exportDOM emits only the filename). "),
    _createElementVNode("a", {
      class: _normalizeClass($data.C.attachment),
      href: $props.url,
      download: "",
      title: $props.fileName,
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.fileName), 1 /* TEXT */)
    ], 10 /* CLASS, PROPS */, _hoisted_1)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}